module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: (("transform: translate(" + _vm.x + "px, " + _vm.y + "px) scale(" + _vm.scale + ");"))
  }, [_c('div', {
    staticClass: "animal",
    domProps: {
      "innerHTML": _vm._s(_vm.image.animal[_vm.playing ? (_vm.animal + "Sound") : _vm.animal])
    }
  }), _vm._v(" "), (_vm.hat) ? _c('div', {
    staticClass: "hat",
    style: (("left: " + (_vm.hatPosition.x * 100) + "%; top: " + (_vm.hatPosition.y * 100) + "%; width: " + (_vm.hat.width * 100) + "%;")),
    domProps: {
      "innerHTML": _vm._s(_vm.image.hat[_vm.hat.key])
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f720c7ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Animal.vue
// module id = 170
// module chunks = 2